import { Component } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { SgbMitraRestService } from '../sgb-mitra-rest.service';
import { ExportDataTableService } from '../../../libraries/export/export-data-table.service';
@Component({
  selector: 'app-sgb-mitra-list',
  templateUrl: 'sgb-mitra-list.component.html'
})
export class SgbMitraListComponent extends BaseListBComponent<any> {
  tableColumns = [
    {
      i18nLabel: 'ui.sgb-mitra.entity.name',
      field: 'name',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.phone',
      field: 'phone',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.email',
      field: 'email',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.storeLocation',
      field: 'storeLocation',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.storeMap',
      field: 'storeMap',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.storeArea',
      field: 'storeArea',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.storeStatusDesc',
      field: 'storeStatusDesc',
      sort: true
    },
    {
      i18nLabel: 'ui.sgb-mitra.entity.storeRoofDesc',
      field: 'storeRoofDesc',
      sort: true
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(
    this.tableColumns
  );
  isLoadingExportExcel: boolean = false;

  constructor(
    private _SgbMitraRest: SgbMitraRestService,
    private _export: ExportDataTableService
  ) {
    super();
    this.componentId = 'SgbMitraListComponent';
    this.headerTitle = 'ui.sgb-mitra.list.title';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign(
          {},
          event.data.qParams,
          qOption,
          this.qParams
        );
        return this._SgbMitraRest.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              d.createdAt = moment(d?.createdAt).format('DD MMMM YYYY');
              return d;
            });
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () =>
        this.page.compHookService?.callMultipleHooks([
          'SgbMitraListComponent:workflowLoadData'
        ])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }

  async onDownloadExcel() {
    this.isLoadingExportExcel = true;

    try {
      const result = await this._SgbMitraRest.findAll({}).toPromise();
      // console.log('esult', result);
      const mapOption = {
        name: { header: 'Nama' },
        phone: { header: 'No WA' },
        email: { header: 'Email' },
        storeLocation: { header: 'Lokasi Toko' },
        storeMap: { header: 'Detail Titik Lokasi' },
        storeArea: { header: 'Luas Bidang Toko' },
        storeStatusDesc: { header: 'Status Toko' },
        storeRoofDesc: { header: 'Keterangan Atap' }
      };
      this._export.export({
        extension: 'xlsx',
        fileName: 'Mitra SGB',
        records: result.data,
        mapOptions: mapOption,
        templateData: null,
        pdfOptions: null
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingExportExcel = false;
    }
  }
}
